import {BrowserRouter, Route, Switch} from "react-router-dom";

import ChangePasswordContainer from "../../common/containers/ChangePasswordContainer.jsx";
import ForgotPasswordContainer from "../../common/containers/ForgotPasswordContainer.jsx";
import LoginContainer from "../../common/containers/LoginContainer.jsx";
import React from "react";
import Router from "./router.jsx";
import SystemMessage from "../../common/components/SystemMessage.jsx";
import {wwwPrefix} from "../../common/util/config.jsx";

export default class RootRouter extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            fatalError: false,
            fatalInfo: undefined,
        };
    }
    componentDidCatch(error, info) {
        const infoStr = `${((error && error.message) || "")}\n\n ${((error && error.stack) || "")} \n${((info && info.componentStack) || "")}`;
        if(infoStr.includes("https://reactjs.org/docs/error-decoder.html?invariant=130&args[]=undefined&args[]=")) {
            this.setState({
                fatalError: true,
                fatalInfo: `Kan vara denna plugin som orsakar problemet: plugin-transform-react-constant-elements\n\nElement type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: undefined.\n\n${infoStr}`
            });
        } else {
            this.setState({
                fatalError: true,
                fatalInfo: infoStr
            });
        }
    }
    render() {
        if(this.state.fatalError) {
            return (
                <React.Fragment>
                    <div className="dim-screen" />
                    <h1>Fatal error</h1>
                    <textarea rows="50" cols="100">{this.state.fatalInfo}</textarea>
                    <br/>
                    Log out button{/*TODO: fix one? */}
                </React.Fragment>
            );
        }
        return (
            <BrowserRouter basename={wwwPrefix}>
                <SystemMessage/>
                <Switch>
                    <Route exact path="/login" component={LoginContainer} />
                    <Route path="/login/forgotPassword" component={ForgotPasswordContainer} />
                    <Route path="/login/restorePassword/:token" component={ChangePasswordContainer} />
                    <Route path="/" component={Router}/>
                </Switch>
            </BrowserRouter>
        );
    }
}